import React, { useState } from "react";
import { motion } from "framer-motion";
import { useCart } from "./CartContext";

const Installation = () => {
  const { addToCart } = useCart();
  const [openDetail, setOpenDetail] = useState("");
  const toggleDetails = (service) => {
    setOpenDetail(openDetail === service ? "" : service);
  };

  const services = [
    {
  title: "Split AC installation",
  price: 1499,
  image: "/images/install.jpg",
  duration: "120 mins",
  process: [
    "We will inspect the spot where you wish to install the AC",
    "Indoor & outdoor units will be installed with proper pipe connections",
    "The area will be cleaned thoroughly after the work is completed",
  ],
},
{
  title: "Window AC installation",
  price: 1099,
  image: "/images/window.jpg",
  duration: "120 mins",
  process: [
    "We will inspect the space where the AC needs to be installed",
    "The AC will be carefully installed in the designated location",
    "Post-installation cleaning will be carried out",
  ],
},
{
  title: "Split AC uninstallation",
  price: 899,
  image: "/images/install.jpg",
  duration: "60 mins",
  process: [
    "We will inspect the location from where the AC needs to be removed",
    "Indoor & outdoor units will be carefully uninstalled with drainage pipe",
    "Cleaning will be done after uninstallation is complete",
  ],
},
{
  title: "Window AC uninstallation",
  price: 699,
  image: "/images/window.jpg",
  duration: "60 mins",
  process: [
    "We will inspect the area from where the AC is to be removed",
    "The AC will be uninstalled carefully without damage",
    "We will clean the place after completing the removal",
  ],
},
];

  const faqs = [
    {
      question: "Is the cost inclusive of spare parts?",
    answer:
      "No, the amount you pay while booking is only a visit charge, which gets adjusted in the final repair bill.",
  },
  {
    question: "How do I confirm if the quote is accurate?",
    answer:
      "Every quote is reviewed by our team. Still unsure? You can talk to a service expert directly through the app.",
  },
  {
    question: "What if I’m asked to pay more than expected?",
    answer:
      "Technicians must follow our fixed pricing. If you feel you're being overcharged, please contact us through the help center.",
  },
  {
    question: "Do spare parts come with a warranty?",
    answer:
      "Yes, parts we provide are covered under warranty. However, parts arranged by you won’t carry any warranty from our side.",
  },
];

  const [openFaq, setOpenFaq] = useState(null);

return (
  <div style={{ padding: 10, maxWidth: 800, margin: "auto" }}>
    <h1 className="text-3xl font-bold mb-6 text-center">
      Installation / Uninstallation Services
    </h1>

    {services.map((service, index) => (
      <div
        key={index}
        style={{
          border: "1px solid #ccc",
          borderRadius: 10,
          padding: 20,
          marginBottom: 20,
          backgroundColor: "#f9f9f9",
        }}
      >
        {/* top row: left content + right image */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 10,
          }}
        >
          {/* Left side */}
          <div style={{ flex: 1, minWidth: "150px" }}>
            <h2 style={{ fontSize: 18, fontWeight: "bold" }}>{service.title}</h2>
            <p style={{ color: "#555" }}>₹{service.price} - {service.time}</p>

            <div style={{ marginTop: 10, display: "flex", gap: 10 }}>
              <button
                onClick={() => toggleDetails(service.title)}
                style={{
                  padding: "6px 12px",
                  backgroundColor: "#007bff",
                  color: "white",
                  border: "none",
                  borderRadius: 5,
                  cursor: "pointer",
                }}
              >
                View Details
              </button>
              <button
                onClick={() => addToCart({ ...service, name: service.title })}
                style={{
                  padding: "6px 12px",
                  backgroundColor: "#28a745",
                  color: "white",
                  border: "none",
                  borderRadius: 5,
                  cursor: "pointer",
                }}
              >
                Add
              </button>
            </div>
          </div>

          {/* Right side: image */}
          <img
            src={service.image}
            alt={service.title}
            className="service-image"
            style={{
              width: 120,
              height: 120,
              objectFit: "cover",
              borderRadius: 10,
              flexShrink: 0,
            }}
          />
        </div>

        {/* details row: alag se neeche full width */}
       {openDetail === service.title && (
                 <motion.div
                   initial={{ y: 30, opacity: 0 }}
                   animate={{ y: 0, opacity: 1 }}
                   transition={{ duration: 0.3 }}
                   style={{
                     marginTop: 15,
                     backgroundColor: "#eef2f7",
                     borderRadius: 8,
                     padding: 15,
                     flexBasis: "100%", // 👈 details neeche full width lega
                   }}
                 >
                  
            <h3 style={{ fontWeight: "bold", marginBottom: 5 }}>
              {service.title}
            </h3>
            <p style={{ marginBottom: 10 }}>
              ₹{service.price} - {service.duration}
            </p>
            <h4 style={{ fontWeight: "bold" }}>Our process</h4>
            <ul style={{ paddingLeft: 20 }}>
              {service.process.map((step, i) => (
                <li key={i} style={{ fontSize: 14 }}>{step}</li>
              ))}
            </ul>
            <h4 style={{ fontWeight: "bold", marginTop: 10 }}>Top technicians</h4>
            <ul style={{ paddingLeft: 20, fontSize: 14 }}>
              <li>Background verified</li>
              <li>Trained across all major brands</li>
            </ul>
            <p style={{ fontSize: 18, marginTop: 5 }}>We Services All brands</p>
          </motion.div>
          )}
        </div>
      ))}

      <div style={{ marginTop: 40 }}>
        <h2 className="text-2xl font-bold mb-4">Frequently Asked Questions</h2>
        {faqs.map((faq, index) => (
          <div
            key={index}
            style={{
              border: "1px solid #ccc",
              borderRadius: 10,
              padding: 20,
              marginBottom: 20,
              backgroundColor: "#f9f9f9",
            }}
          >
            <button
              onClick={() => setOpenFaq(openFaq === index ? null : index)}
              style={{
                width: "100%",
                textAlign: "left",
                background: "none",
                border: "none",
                fontWeight: "bold",
                color: "#007bff",
                cursor: "pointer",
                fontSize: 16
              }}
            >
              {faq.question}
            </button>
            {openFaq === index && (
              <p style={{ marginTop: 10, fontSize: 16, color: "Black" }}>{faq.answer}</p>
            )}
          </div>
        ))}
        <div style={{ height: "400px" }}></div>
      </div>
    </div>
  );
};

export default Installation;
